<template>
  <div>
    <base-card tabled>
      <template v-slot:header>
        <base-card-heading>Documents</base-card-heading>
      </template>
      <template v-if="investment.documents.length">
        <base-table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Uploaded At</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(document, key) in investment.documents" :key="key">
              <td>{{ document.caption }}</td>
              <td>{{ $dates.toDateTime(document.createdAt) }}</td>
              <td class="text-right">
                <div class="btn-group">
                  <base-button :href="$document.path(document)" small target="_blank">
                    Download
                  </base-button>
                  <base-button small @click="remove(document)">
                    Delete
                  </base-button>
                </div>
              </td>
            </tr>
          </tbody>
        </base-table>
      </template>
      <template v-else>
        <p class="text-center">
          No documents have been uploaded yet.
        </p>
      </template>
      <template v-slot:footer>
        <div class="text-right">
          <base-button icon-right="cloud-upload-alt" modal="#uploadInvestmentDocument" secondary>
            Upload Document
          </base-button>
        </div>
      </template>
    </base-card>
    <base-modal small target="uploadInvestmentDocument" title="Upload Document">
      <base-field label="Name">
        <base-input v-model="caption" placeholder="name" />
      </base-field>
      <template v-slot:footer>
        <button-upload block :caption="caption" :path="`investments/${investment._id}/documents`" primary @uploaded="afterUpload">
          Upload Document
        </button-upload>
      </template>
    </base-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import ButtonUpload from './ButtonUpload.vue'

export default {
  name: 'InvestmentDocuments',

  components: {
    ButtonUpload
  },

  data: () => ({
    caption: ''
  }),

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity
    })
  },

  methods: {
    afterUpload (document) {
      this.caption = ''

      this.$modal.close('#uploadInvestmentDocument')

      this.addDocument(document)
    },

    remove (document) {
      this.$dialog.confirm('Are you sure you want to delete this document?')
        .then(({ confirmed }) => {
          if (confirmed) {
            this.removeDocument(document)
          }
        })
    },

    ...mapActions({
      addDocument: 'core/investments/documents/add',
      removeDocument: 'core/investments/documents/pull'
    })
  }
}
</script>
